import React from 'react';

const Circle = () => {
  return <div className="circle"></div>;
};

export default Circle;